import { HTMLAttributes } from 'react'

import Typography from '@/components/base/Typography'
import { useLocaleStore } from '@/store/locale'
import { LANGUAGES } from '@/constants'

import { cn } from '@/lib/utils'

type LanguageListProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    onClose: () => void
    className: string
  }>

const LanguageList: React.FC<LanguageListProps> = ({ className, ...props }) => {
  const [currentLocale, currentTranslations] = useLocaleStore((state) => [
    state.currentLocale,
    state.currentTranslations
  ])

  return (
    <div className={cn('flex items-center gap-[0.8rem]', className)} {...props}>
      {LANGUAGES.map((lang: string, index: number) => (
        <div key={index.toString()}>
          <a
            href={
              currentTranslations?.find((t: { locale: string }) =>
                t.locale.includes(lang)
              )?.href || `/${lang}`
            }
            className={cn('uppercase text-dark-400', {
              'pointer-events-none text-dark-300': lang === currentLocale
            })}
          >
            <Typography variant="small">{lang}</Typography>
          </a>
        </div>
      ))}
    </div>
  )
}

export default LanguageList
